import React from "react";
import teamData from "../data/students.json"; // 1. Import the JSON file

const Team = () => {
  return (
    <section id="team" className="section-alt">
      <div className="section-inner">
        <div className="section-eyebrow">The Roster</div>
        <div className="section-title">Meet the Knights</div>
        <div className="section-divider"></div>

        <div className="team-grid">
          {/* 2. Use the imported data to map the cards */}
          {teamData.map((member, index) => (
            <div className={`team-card ${member.type}`} key={index}>
              <div className="team-avatar">{member.initials}</div>
              <div className="team-name">{member.name}</div>
              <div className="team-role">{member.role}</div>
              <div className="team-desc">{member.desc}</div>
            </div>
          ))}

          {/* The constant "Join Us" card at the end */}
          <div className="team-card join-us">
            <div className="team-avatar">+</div>
            <div className="team-name">Join Us</div>
            <div className="team-role">Open Spots</div>
            <div className="team-desc">Interested in joining the Knights?</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
